export default {"src":"/_next/static/media/metis.90b6abf0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};